"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSEPReviewComponent = void 0;
const core_1 = require("@angular/core");
const expresspay_services_1 = require("../../../shared/services/expresspay.services");
const helper_service_1 = require("../../../../mma/shared/services/helper.service");
const shared_1 = require("../../../../mma/shared");
const _ = require("underscore");
class CSEPReviewComponent {
    constructor(genericContentServiceV2, expressPayService, helperService) {
        this.genericContentServiceV2 = genericContentServiceV2;
        this.expressPayService = expressPayService;
        this.helperService = helperService;
        this.edit = new core_1.EventEmitter();
        this.next = new core_1.EventEmitter();
        this.paymentType = new core_1.EventEmitter();
        this.confirmationNumber = new core_1.EventEmitter();
        this.genericError904 = new core_1.EventEmitter();
        this.classes = 'col-12';
        this.disablePaymentButton = false;
        this.scrollTop();
    }
    ngOnInit() {
        this.payAmount = true;
        this.paymentMethod = this.paymentMethodData.setPaymentMethod;
        // to check if the user has valid session or not
        this.isAuthenticated();
        this.getBillingAddress();
        this.getSessionId();
        this.helpUrl = '/help/solution-details/?'
            + 'lob=wireless&lang=en&permaLink=how-to-make-extra-payments-on-your-device--generic-phone--en--0--1&responseId=20--EjWclklgRJJPQQiXgcbjaXR2sBWb0lmt';
        this.getGenericContent();
    }
    editPaymentInfo() {
        this.paymentDetails = null;
        this.funds = null;
        this.giftCardData = null;
        this.bankAccountDetails = null;
        this.edit.emit(true);
    }
    submit(reviewPaymentDetails) {
        this.error = null;
        this.scrollTop();
        this.disablePaymentButton = true;
        this.paymentMethod = this.paymentMethodData.setPaymentMethod;
        if (this.paymentMethodData.setPaymentMethod === 'GIFT_CARD') {
            const content = {
                'amountToPay': this.funds.amountToPay,
                'payInFull': this.funds.payInFull,
                'payPastDueBalance': this.funds.payPastDueBalance,
                'giftCard': {
                    'gcNumber': this.giftCardData.giftCardNumber,
                    'gcPin': this.giftCardData.giftCardPin,
                    'gcBalance': this.giftCardData.giftCardBalance,
                }
            };
            this.loader = true;
            this.expressPayService.submitPaymentByGiftCard(content).subscribe((data) => {
                this.loader = false;
                this.paymentType.emit(this.paymentMethod);
                this.confirmationNumber.emit(data.authCode);
                this.next.emit(true);
            }, (err) => {
                this.handleSubmitError(err);
            });
        }
        else if (this.paymentMethodData.setPaymentMethod === 'BANK_ACCOUNT') {
            let content = {};
            content = this.payByBankAccount(this.bankAccountDetails, this.funds, reviewPaymentDetails);
            this.loader = true;
            this.expressPayService.submitBankAccountDetails(content).subscribe((data) => {
                this.loader = false;
                if (!this.funds.scheduledFutureDate) {
                    this.confirmationNumber.emit(data.bankAccount.authCode);
                }
                this.paymentType.emit(this.paymentMethod);
                this.genericError904.emit(data.errorIdOnPaymentSuccess);
                this.next.emit(true);
            }, (err) => {
                this.handleSubmitError(err);
            });
        }
        else {
            const ccContents = this.payByCreditCard(this.ccContentData, reviewPaymentDetails);
            this.loader = true;
            this.expressPayService.submitFinalPayment(ccContents).subscribe((res) => {
                this.loader = false;
                if (!this.funds.scheduledFutureDate) {
                    this.confirmationNumber.emit(res.creditCard.authCode);
                }
                this.paymentType.emit(this.paymentMethod);
                this.genericError904.emit(res.errorIdOnPaymentSuccess);
                this.next.emit(true);
            }, (err) => {
                this.handleSubmitError(err);
            });
        }
    }
    handleSubmitError(err) {
        this.loader = false;
        this.error = err;
        this.disablePaymentButton = false;
        this.scrollTop();
    }
    convertDateToString(date) {
        const d = new Date(date);
        const year = d.getFullYear();
        let month = '' + (d.getMonth() + 1);
        let day = '' + d.getDate();
        if (month.length < 2) {
            month = '0' + month;
        }
        if (day.length < 2) {
            day = '0' + day;
        }
        return [year, month, day].join('-');
    }
    payByCreditCard(ccContent, reviewPaymentDetails) {
        const schdDate = this.convertDateToString(new Date(this.funds.newScheduledDate));
        // let content = {};
        const content = {
            newScheduledDate: schdDate,
            scheduledFutureDate: this.funds.scheduledFutureDate,
            amountToPay: ccContent.amountToPay,
            convenienceFeeAmount: ccContent.convenienceFeeAmount,
            bankAccount: ccContent.bankAccount,
            termsAndConditions: reviewPaymentDetails.termscondition,
            giftCard: ccContent.giftCard,
            mobileNumber: ccContent.mobileNumber,
            payInFull: ccContent.payInFull,
            payPastDueBalance: ccContent.payPastDueBalance,
            prepaid: ccContent.prepaid,
            savePaymentInfo: ccContent.savePaymentInfo,
            subscriptionId: ccContent.subscriptionId,
            creditCard: {
                amountToPay: ccContent.creditCard.amountToPay,
                authCode: ccContent.creditCard.authCode,
                ccAddrSameAsBillingAddr: ccContent.creditCard.ccAddrSameAsBillingAddr,
                ccNumber: ccContent.creditCard.ccNumber,
                ccRepositoryId: ccContent.creditCard.ccRepositoryId,
                ccType: ccContent.creditCard.ccType,
                cvv: ccContent.creditCard.cvv,
                expMonth: ccContent.creditCard.expMonth,
                expYear: ccContent.creditCard.expYear,
                kHashToken: ccContent.creditCard.kHashToken,
                newCreditCard: ccContent.creditCard.newCreditCard,
                savedCcIndex: ccContent.creditCard.savedCcIndex,
                ccAddress: {
                    addressLine1: ccContent.creditCard.ccAddress.addressLine1,
                    addressLine2: ccContent.creditCard.ccAddress.addressLine2,
                    addressSelected: ccContent.creditCard.ccAddress.addressSelected,
                    city: ccContent.creditCard.ccAddress.city,
                    firstName: ccContent.creditCard.ccAddress.firstName,
                    lastName: ccContent.creditCard.ccAddress.lastName,
                    state: ccContent.creditCard.ccAddress.state,
                    zipCode: ccContent.creditCard.ccAddress.zipCode
                }
            }
        };
        return content;
    }
    payByBankAccount(details, funds, reviewPaymentDetails) {
        const schdDate = this.convertDateToString(new Date(this.funds.newScheduledDate));
        let content = {};
        content = {
            'newScheduledDate': schdDate,
            'scheduledFutureDate': this.funds.scheduledFutureDate,
            'amountToPay': funds.amountToPay,
            'payInFull': funds.payInFull,
            'payPastDueBalance': funds.payPastDueBalance,
            'termsAndConditions': reviewPaymentDetails.termscondition,
            'bankAccount': {
                'routingNumber': details.bankAccount.routingNumber,
                'routingNumberConfirm': details.bankAccount.routingNumberConfirm,
                'bankAccountNumber': details.bankAccount.bankAccountNumber,
                'bankAccountNumberConfirm': details.bankAccount.bankAccountNumberConfirm,
                'checkNumber': '1',
                'checkType': details.bankAccount.checkType,
                'differentBankAccount': true,
                'address': {
                    'addressSelected': details.bankAccount.address.addressSelected,
                    'firstName': details.bankAccount.address.firstName,
                    'lastName': details.bankAccount.address.lastNmae,
                    'addressLine1': details.bankAccount.address.addressLine1,
                    'addressLine2': details.bankAccount.address.addressLine2,
                    'city': details.bankAccount.address.city,
                    'state': details.bankAccount.address.state,
                    'zipCode': details.bankAccount.address.zipCode
                }
            }
        };
        return content;
    }
    getBillingAddress() {
        this.expressPayService.getPersonalInformation().subscribe((res) => {
            this.personalInfo = res;
        }, (err) => {
            this.error = err;
        });
    }
    getSessionId() {
        this.expressPayService.getSessionId().subscribe((res) => {
            this.riskSessionIdUrl = '/global/logo.jsp?sessionId=' + res.riskSessionId;
        }, (err) => {
            this.error = err;
        });
    }
    inputOnlyNumber(event) {
        return (event.charCode === 8 || event.charCode === 0) ? null : event.charCode >= 48 && event.charCode <= 57;
    }
    scrollTop() {
        window.scrollTo(0, 200);
    }
    // code to check if the user has valid session or not
    isAuthenticated() {
        this.loader = true;
        this.expressPayService.loginAuthentication().subscribe((data) => {
            if (_.isEmpty(data)) {
                this.hidePage = true;
                this.helperService.onNavigate('/my_account/personal/express-pay/');
            }
            this.loader = false;
        }, (err) => {
            this.loader = false;
        });
    }
    getGenericContent() {
        const genericContentIds = [
            '/generic/agreement/draftEFTTerms',
            'genericConvenienceFeeNote'
        ];
        this.genericContentServiceV2.getBulkGenericContent(genericContentIds).subscribe((bulkGenericContent) => {
            for (const genericContentItem of bulkGenericContent) {
                if (genericContentItem.id === '/generic/agreement/draftEFTTerms') {
                    this.termsAndConditionInfo = genericContentItem;
                }
                if (genericContentItem.id === 'genericConvenienceFeeNote') {
                    this.convenienceFeeNote = genericContentItem.content;
                }
            }
        }, () => {
            this.termsAndConditionInfo = '';
            this.convenienceFeeNote = '';
        });
    }
}
exports.CSEPReviewComponent = CSEPReviewComponent;
//# sourceMappingURL=review.component.js.map